/* global $ */
import * as d3 from 'd3'

export default function LoadCatchRates(options) {
    const margin = { top: 20, right: 90, bottom: 50, left: 50 }
    const width = options.width - margin.left - margin.right
    const height = options.height - margin.top - margin.bottom

    const x = d3.scaleLinear().range([0, width])
    const y = d3.scaleLinear().range([height, 0])
    // const z = d3.scaleLinear().range(['white', 'red'])

    // var colors = ["#3661ad", "#3560aa", "#335da5", "#31589c", "#2e5391", "#294b83", "#254271", "#213a60", "#192c46", "#4a1d23", "#6d1b22", "#851e25", "#9c1d25", "#b01e26", "#c02028", "#cc2028", "#d42129", "#d82129"];
    const colors = [
        '#3661AD',
        '#4C72B6',
        '#6284BF',
        '#7995C8',
        '#8FA7D1',
        '#A5B8DA',
        '#BCCAE3',
        '#D2DBEC',
        '#E8EDF5',
        '#FFFFFF',
        '#FAE3E4',
        '#F5C7C9',
        '#F0ABAE',
        '#EB9094',
        '#E67479',
        '#E1585E',
        '#DC3C43',
        '#D82129',
    ]

    const colorTile = d3
        .scaleLinear()
        .domain(d3.range(0, 100, 7))
        .range(colors.reverse())

    // The size of the catches in the CSV data file.
    // This could be inferred from the data if it weren't sparse.
    const xStep = 5
    const yStep = 0.1

    const svg = d3
        .select(`#${options.div_id}`)
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)

    d3.json('/statcast_catch_probability?hang_time=all').then(
        (catches) => {
            // Compute the scale domains.
            // x.domain(d3.extent(catches, function(d) { return d.distance; }));
            y.domain(d3.extent(catches, (d) => d.opportunity_time))

            // Extend the x- and y-domain to fit the last bucket.
            // For example, the y-bucket 3200 corresponds to values [3200, 3300].
            x.domain([0, 140])
            // y.domain([3, 7.8]);

            // Display the tiles for each non-zero bucket.
            // See http://bl.ocks.org/3074470 for an alternative implementation.
            svg.selectAll('.tile')
                .data(catches)
                .enter()
                .append('rect')
                .attr('class', 'tile')
                .attr('x', (d) => x(d.distance))
                .attr('y', (d) => y(d.opportunity_time))
                .attr('width', x(xStep) - x(0))
                .attr('height', y(0) - y(yStep))
                .style('fill', (d) => colorTile(d.catch_rate))
                .attr('meta', (d) => d.catch_rate)
                // .style("stroke", "#000000")
                .on('mouseover', (d, event) => {
                    $('#tip').html(
                        `<h4>Opportunity Time: ${event.opportunity_time} Distance: ${event.distance} Balls Landed: ${event.balls_landed} Batted Balls: ${event.balls_in_play} Catch Rate: ${event.catch_rate} Land Rate: ${event.land_rate}</h4>`
                    )
                })

            // Add a legend for the color values.
            const legend = svg
                .selectAll('.legend')
                .data(colorTile.ticks(10).slice(1).reverse())
                .enter()
                .append('g')
                .attr('class', 'legend')
                .attr(
                    'transform',
                    (d, i) => `translate(${width + 20},${20 + i * 20})`
                )

            legend
                .append('rect')
                .attr('width', 20)
                .attr('height', 20)
                .style('fill', colorTile)

            legend
                .append('text')
                .attr('x', 26)
                .attr('y', 10)
                .attr('dy', '.35em')
                .text(String)

            svg.append('text')
                .attr('class', 'label')
                .attr('x', width + 20)
                .attr('y', 10)
                .attr('dy', '.35em')
                .text('Catch Rate')

            // Add an x-axis with label.
            svg.append('g')
                .attr('class', 'x axis')
                .attr('transform', `translate(0,${height + 8})`)
                .call(d3.axisBottom().scale(x).ticks(17))

            svg.append('text')
                .attr('class', 'label')
                .attr(
                    'transform',
                    `translate(${width / 2} ,${height + margin.top + 25})`
                )
                .style('text-anchor', 'middle')
                .text('Distance (ft.)')

            // Add a y-axis with label.
            svg.append('g')
                .attr('class', 'y axis')
                .attr('transform', `translate(0,${10})`)
                .call(d3.axisLeft().scale(y))

            svg.append('text')
                .attr('class', 'label')
                .attr('transform', 'rotate(-90)')
                .attr('y', 0 - margin.left)
                .attr('x', 0 - height / 2)
                .attr('dy', '1em')
                .style('text-anchor', 'middle')
                .text('Opportunity Time (sec.)')
        },
        (err) => {
            // eslint-disable-next-line no-console
            console.error(err)
        }
    )
}
